






import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ReviewStar',
  props: {
    rating: {
      type: Number,
      required: true,
    },
    selectedRating: {
      type: Number,
      required: true,
    },
    hoverRating: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const starIcon = computed(() =>
      props.rating <= props.hoverRating || props.rating <= props.selectedRating
        ? 'iconify svg--star'
        : 'iconify svg--star-empty',
    );

    return {
      starIcon,
    };
  },
});
